import React from 'react';
import images from './assets/images';

export const ImagesVariable = () => {
    return (
        <>
            <style>
                {`
                    :root {
                        --lockSVG: url(${images.lockSVG});
                        --unlockSVG: url(${images.unlockSVG});
                        --creditCardBg: url(${images.creditcardBgPNG});
                        --downSVG: url(${images.downSVG});
                        --closeBSVG: url(${images.closeBSVG});
                        --searchSVG: url('/images/search-icon.svg');
                        --closeSVG: url(${images.closeSVG});
                        --resetIconSVG: url(${images.reseticonSVG});
                        --noImageFoundJPG: url(${images.noimagefoundJPG});
                        --downArrowSVG: url(${images.downArrowSVG});
                        --icDateSVG: url(${images.icdateSVG});
                        --arrowMobileSVG: url(${images.arrowMobileSVG});
                        --loginBackgroundJPG: url(${images.loginbackgroundJPG});
                        --loginBgShapeSVG: url(${images.loginbgshapesSVG});
                        --loginBgShape02SVG: url(${images.loginbgshapes02SVG});
                        --sortingSVG: url(${images.sortingSVG});
                        --sortingASCSVG: url(${images.sortingascSVG});
                        --sortingDESCSVG: url(${images.sortingdescSVG});
                        --successIconSVG: url(${images.successiconSVG});
                        --warningIconSVG: url(${images.warningIconSVG});
                        --errorIconSVG: url(${images.errorIconSVG});
                        --infoIconSVG: url(${images.infoiconSVG});
                    }
                `}
            </style>
        </>
    );
};
